import { Link } from "react-router-dom";
import Icons from "../../myIcon/Icons";

export default function AboutVision({visionData}) {
  return (
    <>
    <section className="aboutpage-vision">
        <div className="container">
            <div className="row">  

                <div className="col-lg-3 col-md-3 order-2 order-md-1 order-lg-1">
                    <div className="aboutvision-image">
                        <img src={visionData.leftImage} loading="lazy" className="img-responsive wow animate__animated animate__fadeInLeft" data-wow-duration="1s" data-wow-delay="0.2s" alt="vision"/>
                    </div>
                </div>

                <div className="col-lg-4 col-md-4 order-1 order-md-2 order-lg-2">
                    <div className="aboutvision-text">
                        <h4 className="heading">{visionData.heading}</h4>
                        <p>{visionData.text}</p>
                        <Link to={"/contact"} className="default-btn colored-btn">Get in Touch <Icons name="Longarrow_right"/></Link>
                    </div>
                </div>

                <div className="col-lg-5 col-md-5 order-3 order-md-3 order-lg-3">
                    <img src={visionData.rightImage} loading="lazy" className="img-responsive wow animate__animated animate__fadeInRight" data-wow-duration="1.1s" data-wow-delay="0.2s" alt="vision"/>
                </div>
            </div>
        </div>
    </section>
    </>
  )
}
